import { connect } from "react-redux";
import { AbTest as Component } from "./component";
import { selectAbTestRunning, selectAbTestVersion } from "./selectors";

/**
 * @param state {Record<typeof import('./constants').AB_TEST_STATE, typeof import('./reducer').abTestInitialState>}
 */
const mapStateToProps = (state) => ({
  running: selectAbTestRunning(state),
  currentVersion: selectAbTestVersion(state),
});

export const AbTest = connect(mapStateToProps)(Component);
